module.exports = __webpack_public_path__ + "static/media/taxi-promocode.a39e2ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taxi-promocode.png
// module id = 346
// module chunks = 0